// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import router from './router'

import 'babel-polyfill'

// vue-quill-editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, /* { default global options } */)

// 全局参数
// Vue.prototype.$frontUrl = '192.168.11.229' // 前端地址
Vue.prototype.$baseUrl = 'http://sc.tjzzk.hbdfwx.com' // 后台地址
Vue.prototype.$loginName = 'LOGIN_NAME' // cookies 用户名
Vue.prototype.$loginCode = 'LOGIN_CODE' // cookies 登录code
Vue.prototype.$domain = '.hbdfwx.com' // 域名
// 综合运营平台登录用参数
Vue.prototype.$hcpmUrl = 'http://ucenter.cjaipub.com/'
Vue.prototype.$hcpmLogin = 'login-modal?pageTypes=login&clientId=8ccccb6f23877a9ff3d1240ee38410b1&callback=http://sc.tjzzk.hbdfwx.com/zhyypt/singleLoginNew&logoutUrl=http://sc.tjzzk.hbdfwx.com/zhyypt/singleLogout'
Vue.prototype.$hcpmLogout = 'login-out'

// 是否显示登录popup
Vue.prototype.$showLogin = false
// axios
import axios from 'axios'
Vue.prototype.axios = axios
var $http = axios.create({
　baseURL: Vue.prototype.$baseUrl,
  withCredentials: true,
// 　timeout: '6000',  //请求超时时间
　headers: {'X-Custom-Header': 'foobar',"Access-Control-Allow-Origin":"*"}     //header传值，例如：Authorization
})
Vue.prototype.$http = $http
Vue.config.productionTip = false

// 综合运营平台用户中心
var $httpGateway = axios.create({
　baseURL: Vue.prototype.$userCenter,
  // withCredentials: true,
// 　timeout: '6000',  //请求超时时间
　headers: {
    // 'X-Custom-Header': 'foobar',
    // 'Access-Control-Allow-Origin': '*',
  }
})
Vue.prototype.$httpGateway = $httpGateway

// VueCookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

var startTiming = 0;  // 进入页面的时间点
var blurTiming = 0;  // 失去焦点的时间点
var blurDuration = 0;  // 焦点不在页面的时间长度

// 页面失去焦点
window.onblur = function() {
  blurTiming = new Date();  // 失去焦点的时间点
}

// 页面获取焦点
window.onfocus = function() {
  var focusTiming = new Date();  // 获取焦点的时间点

  // 累加 计算失去焦点的总时长
  if (blurTiming != 0) {
    blurDuration += (Date.parse(focusTiming) - Date.parse(blurTiming)) / 1000
  }
}

// 关闭、刷新页面事件
window.onbeforeunload = function() {
  // 记录页面停留时长
  Vue.prototype.getStayDuration();
}

/** 全局前置守卫 */
router.beforeEach((to, from, next) => {
  if(to.query.loginFlag == '1') {
    delete to.query.loginFlag
    if(self != top){
      top.location.reload()
    }
  }

  // 记录页面访问请求
  getAccess(to)
  // 记录页面停留时长
  Vue.prototype.getStayDuration();

  // 获取用户名
  var loginName = $cookies.get(Vue.prototype.$loginName);
  if (loginName) {
    next();
  } else {
    // 登录拦截 判断该路由是否需要登录权限
    if (to.meta.requireAuth) {
      Vue.prototype.$showLogin = true
      next({
        path: '/'
      })
    } else {
      // 不需要登录的页面
      var img = new Image(1, 1);
      img.src = Vue.prototype.$hcpmUrl + Vue.prototype.$hcpmLogin
      next()
    }
  }
})

/** 全局后置钩子 */ 
router.afterEach((to,from,next) => {
  // 路由改变时 回到顶部
  window.scrollTo(0,0);

  // 进入页面的时间点
  startTiming = new Date();

  // 失焦时间长度归零  
  blurDuration = 0;
})


/** 前端埋点 数据收集 */
Vue.prototype.getAnalysisData = function (event, targetId, key, value, extra){

  var userId = '';
  var loginName = $cookies.get(Vue.prototype.$loginName);
  if (loginName) {
    userId = loginName
  }
  var args = 'user_id=' + userId 
    + '&project=tjzbk'
    + '&event=' + event 
    + '&target_id=' + targetId 
    + '&key=' + key 
    + '&value=' + value
    + '&extra=' + extra;
  var img = new Image(1, 1);
  img.src = 'http://47.111.125.180/log.gif?' + args;
}

/** 记录页面停留时长 */
Vue.prototype.getStayDuration = function() {
  // 离开上个页面的时间点
  var leaveTiming = new Date();
  
  // 离开页面 - 进入页面的时间长度
  if (startTiming != 0) {
    var stayDuration = (Date.parse(leaveTiming) - Date.parse(startTiming)) / 1000;
  }

  var url = window.location.pathname
  // 真实的页面停留时长 = 总时长 - 失焦时长
  var duration = stayDuration - blurDuration;
  if (duration && duration > 3) {
    // 收集页面停留时长
    Vue.prototype.getAnalysisData('stay', url, 'time', duration, '');
  }
}

/** 记录页面访问 */
function getAccess(to) {
  // 请求参数
  var query = to.query
  // 请求路径
  var path = to.path

  var key = ''
  var value = ''
  // 百科搜索
  if(path == '/baikeSearch') {
    key = 'word'
    value = query[key]
  } else if(path == '/homeSearch') {
    // 全站搜索
    key = 'word'
    value = query[key]
  }
  // 收集
  Vue.prototype.getAnalysisData('access', path, key, value, '')
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js